import { openDB } from 'idb';

const DB_NAME = 'sps';
const VERSION = 1;

export async function openDb() {
  return openDB(DB_NAME, VERSION, {
    upgrade(db) {
      const families = db.createObjectStore('families', { keyPath: 'family_key' });
      families.createIndex('by_mandal', 'mandal');
      const people = db.createObjectStore('people', { keyPath: 'member_id' });
      people.createIndex('by_family_key', 'family_key');
      const handovers = db.createObjectStore('handovers', { keyPath: 'id' });
      handovers.createIndex('by_family_key', 'family_key');
      handovers.createIndex('by_client_id', 'client_id');
      db.createObjectStore('outbox', { keyPath: 'client_id' });
      db.createObjectStore('meta', { keyPath: 'k' });
    },
  });
}

export async function putMany(db, store, rows) {
  if (!rows?.length) return;
  const tx = db.transaction(store, 'readwrite');
  await Promise.all(rows.map((r) => tx.store.put(r)));
  await tx.done;
}

export async function getAll(db, store) {
  return db.getAll(store);
}

export async function getByIndex(db, store, index, value) {
  return db.getAllFromIndex(store, index, value);
}

export async function deleteBy(db, store, key) {
  return db.delete(store, key);
}

export async function getMeta(db, k) {
  const row = await db.get('meta', k);
  return row?.v;
}
export async function setMeta(db, k, v) {
  return db.put('meta', { k, v });
}
